import API from './base';

class ReviewsAPI extends API {
  getReasons() {
    return this.get('/api/web/v1/review_report_reasons');
  }

  sendReport(payload) {
    return this.post('/api/web/v1/review_reports', payload);
  }

  sendAnswer(payload) {
    return this.patch(`/api/web/v1/reviews/${payload.id}`, payload);
  }

  sendExamCenterReport(payload) {
    return this.post('/api/web/v1/exam_center_review_reports', payload);
  }

  getExamCenterReasons() {
    return this.get('/api/web/v1/exam_center_review_report_reasons');
  }

  sendExamCenterAnswer(payload) {
    return this.patch(`/api/web/v1/exam_center_reviews/${payload.id}`, payload);
  }
}

export default new ReviewsAPI();
